import { AppError } from '../models/error';

export interface GatewayConfig {
  environment: string;
  gatewayType: string;
  publicClientKey: string;
  threeDsEnabled: boolean;
}

export interface GatewayConfigState {
  config: GatewayConfig | null;
  loading: boolean;
  error: AppError | null;
}

export const INITIAL_GATEWAY_CONFIG_STATE: GatewayConfigState = {
  config: null,
  loading: false,
  error: null,
};
